import { create } from 'zustand';

export const useLanguageTransitionStore = create(set => ({
  isChangingLanguage: false,
  setIsChangingLanguage: value => set({ isChangingLanguage: value }),
}));
